import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.string.sub";
var r = 15;

function i() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 15;
  return t.length > e ? t.substring(0, e - 3) + "..." : t;
}

function a(t) {
  var e = t == null ? void 0 : t.given_name,
      n = t == null ? void 0 : t.family_name;
  return !e && !n ? "My Profile" : e && !n ? i(e) : !e && n ? i(n) : "".concat(i(e), " ").concat(n.charAt(0), ".");
}

function o(t) {
  var e = t == null ? void 0 : t.given_name,
      n = t == null ? void 0 : t.family_name;
  return !e && !n ? "me" : e && !n ? e.charAt(0).toLowerCase() : !e && n ? n.charAt(0).toLowerCase() : "".concat(e.charAt(0).toLowerCase()).concat(n.charAt(0).toLowerCase());
}

function f(t) {
  return t && typeof t == "object" && "sub" in t && typeof t.sub == "string" && t.sub.trim() !== "" && Object.keys(t).length > 0;
}

export { o as getFirstInitialLastInitial, a as getFirstNameLastInitial, f as isValidUser, i as truncateString };